export default function prepareCart(cart) {
  const newCart = [];
  const cartPromoCode = cart.find((item) => item.type === 'promoCode');
  cart.forEach((item) => {
    let newItem = {};
    if (item.type !== 'guidedTour') {
      Object.assign(newItem, item);
    }
    if (item.type === 'guidedTour') {
      newItem = {};
      newItem.type = 'guidedTour';
      newItem.answers = item.answers;
      newItem.datetime = `${item.date} ${item.time}:00`;
      newItem.tourId = item.tourId;

      newItem.prices = [];

      item.tours.forEach((t) => {
        const price = {
          id: t.id,
          count: t.count,
          //discountId: t.discountId,
        };
        if (t.discountId) {
          price.discountId = t.discountId;
        } else if (item.discountId) {
          price.discountId = item.discountId;
          price.keyword = item.keyword;
        } else if (cartPromoCode) {
          price.discountId = cartPromoCode.id;
          price.keyword = cartPromoCode.keyword;
        }
        newItem.prices.push(price);
      });
      newItem.tickets = [];
      item.tickets.forEach((ticket) => {
        const newTicket = {
          id: ticket.id,
          count: ticket.count,
          discountId: ticket.discountId || (cartPromoCode ? cartPromoCode.id : undefined),
          keyword: ticket.keyword || (cartPromoCode ? cartPromoCode.keyword : undefined),
        };
        if (typeof ticket.subtickets !== 'undefined') {
          newTicket.subtickets = [];
          ticket.subtickets.forEach((subticket) => {
            newTicket.subtickets.push({
              id: subticket.id,
              count: subticket.count,
              discountId: subticket.discountId || (cartPromoCode ? cartPromoCode.id : undefined),
              keyword: subticket.keyword || (cartPromoCode ? cartPromoCode.keyword : undefined),
            });
          });
        }
        newItem.tickets.push(newTicket);
      });
      newCart.push(newItem);
    } else if (item.type === 'ticket') {
      let seats = [];
      if (typeof newItem.seats !== 'undefined') {
        newItem.seats.forEach((seat) => {
          seats.push(seat.id);
        });
      }
      const t = {
        type: 'ticket',
        count: newItem.totalCount,
        id: newItem.id,
        datetime: newItem.datetime,
        discountId: newItem.discountId || (cartPromoCode ? cartPromoCode.id : undefined),
        keyword: newItem.keyword || (cartPromoCode ? cartPromoCode.keyword : undefined),
        seats: seats,
      };
      if (typeof newItem.answers !== 'undefined' && newItem.answers.length > 0) {
        t.answers = newItem.answers;
      }
      if (typeof newItem.subtickets !== 'undefined') {
        t.subtickets = [];
        newItem.subtickets.forEach((st) => {
          t.subtickets.push({
            id: parseInt(st.id, 10),
            count: st.count,
            discountId: st.discountId || (cartPromoCode ? cartPromoCode.id : undefined),
            keyword: st.keyword || (cartPromoCode ? cartPromoCode.keyword : undefined),
          });
        });
      }
      newCart.push(t);
    } else if (item.type === 'voucherCode') {
      const v = {
        type: 'voucherCode',
        barcode: newItem.barcode,
      };
      newCart.push(v);
    } else if (item.type !== 'promoCode') {
      if (cartPromoCode && !newItem.discountId) {
        newItem.discountId = cartPromoCode.id;
        newItem.keyword = cartPromoCode.keyword;
      }
      newCart.push(newItem);
    }
  });
  return newCart;
}
